module.exports = __webpack_public_path__ + "public/img/arrow-rt.5b766b9b.svg";